// 粉丝管理
import {post} from './http';
const baseUrl = '/api/admin/fans';

// 粉丝列表分页查询
export const findAllFans = v => post(`${baseUrl}/findAllFans`,v.data,v.success,v.error);

// 获取粉丝详细信息
export const getFansInfo = v => post(`${baseUrl}/getFansInfo`,v.data,v.success,v.error);

// 添加粉丝备注
export const saveFansMemo = v => post(`${baseUrl}/saveFansMemo`,v.data,v.success,v.error);

// 订单粉丝列表
export const findOrderFansList = v => post(`${baseUrl}/findOrderFansList`,v.data,v.success,v.error);

// 公众号粉丝列表
export const findMPThdUserSubscribeInfoList = v => post(`${baseUrl}/findMPThdUserSubscribeInfoList`,v.data,v.success,v.error);